module.exports = __webpack_public_path__ + "static/media/98mm.87d7ae5f.png";